import { useMemo } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import { Typography } from "@components/atoms/typography";
import type { IPageTabsProps } from "@components/atoms/pageTabs/types";

export function PageTabs<T extends string = string>(props: IPageTabsProps<T>) {
  const { tabs, selectedKey, onChange } = props;

  const renderTabs = useMemo(() => {
    return tabs?.map((tab) => {
      const countMode = tab?.count !== undefined;

      return (
        <div
          key={tab?.key}
          className={clsx(
            classes.tabContainer__tab,
            countMode && classes.tabContainer__countModeTab,
            selectedKey === tab?.key && classes?.tabContainer__selectedTab,
          )}
          onClick={() => {
            onChange(tab?.key);
          }}
        >
          <div className={clsx(classes.tabContainer__tabInside)}>
            <Typography color={"inherit"}>{tab?.title}</Typography>
            {countMode && (
              <div
                className={clsx(
                  classes.tabContainer__count,
                  selectedKey === tab?.key &&
                    classes?.tabContainer__selectedCount,
                )}
              >
                <Typography
                  variant={"caption2"}
                  color={"inherit"}
                  fontSize={"sm"}
                >
                  {tab?.count}
                </Typography>
              </div>
            )}
          </div>
        </div>
      );
    });
  }, [onChange, selectedKey, tabs]);

  return <div className={clsx(classes.tabContainer)}>{renderTabs}</div>;
}
